export default {
  seeds: [
    [
      {
        album: "Taylor Swift",
        album_num: 9,
        song: "Invisible",
        line: {
          prev: "Let me want you",
          this: "You just see right through me",
          next: "But if you only knew me",
          num: 40,
          section: "[Chorus]",
        },
      },
      {
        album: "Reputation",
        album_num: 4,
        song: "New Year's Day",
        line: {
          prev: "And I will hold on to you",
          this: "Please don't ever become a stranger",
          next: "Whose laugh I could recognize anywhere",
          num: 21,
          section: "[Bridge]",
        },
      },
      {
        album: "1989",
        album_num: 5,
        song: "Wonderland",
        line: {
          prev: "And spinning out of control",
          this: "Didn't they tell us don't rush into things?",
          next: "Didn't you flash your green eyes at me?",
          num: 7,
          section: "[Pre-Chorus]",
        },
      },
      {
        album: "1989",
        album_num: 5,
        song: "I Wish You Would",
        line: {
          prev: "I wish you would",
          this: "(I, I, I, I, I, I wish I, wish I)",
          next: "You always knew how to push my buttons",
          num: 65,
          section: "[Outro]",
        },
      },
      {
        album: "Unspecified Album",
        album_num: 10,
        song: "Babe",
        line: {
          prev: "How could you do this, babe?",
          this: "This is the last time, this is the last time",
          next: "This is the last time I'll ever call you, babe",
          num: 33,
          section: "[Chorus: Sugarland & Taylor Swift]",
        },
      },
      {
        album: "Fearless (Taylor's Version)",
        album_num: 8,
        song: "The Other Side Of The Door (Taylor's Version)",
        line: {
          prev: "I said, 'Leave,' but all I really want is you",
          this: "To stand outside my window throwin' pebbles",
          next: "Screamin', 'I'm in love with you'",
          num: 24,
          section: "[Chorus]",
        },
      },
      {
        album: "folklore",
        album_num: 2,
        song: "mirrorball",
        line: {
          prev: "Shining just for you",
          this: "Hush, I know they said the end is near",
          next: "But I'm still on my tallest tiptoes",
          num: 11,
          section: "[Chorus]",
        },
      },
      {
        album: "folklore",
        album_num: 2,
        song: "cardigan",
        line: {
          prev: "Leavin' like a father",
          this: "Running like water, I",
          next: "And when you are young, they assume you know nothing",
          num: 40,
          section: "[Chorus]",
        },
      },
      {
        album: "Taylor Swift",
        album_num: 9,
        song: "Stay Beautiful",
        line: {
          prev: "And when you find everything you looked for",
          this: "I hope your life will lead you back to my door",
          next: "Oh, but if it don't",
          num: 27,
          section: "[Chorus]",
        },
      },
      {
        album: "Reputation",
        album_num: 4,
        song: "Getaway Car",
        line: {
          prev: "I was cryin' in a getaway car",
          this: "I was dyin' in a getaway car",
          next: "Said goodbye in a getaway car",
          num: 74,
          section: "[Outro]",
        },
      },
      {
        album: "Reputation",
        album_num: 4,
        song: "Dress",
        line: {
          prev: "Say my name and everything just stops",
          this: "I don't want you like a best friend",
          next: "Only bought this dress so you could take it off",
          num: 32,
          section: "[Chorus]",
        },
      },
      {
        album: "Red (Taylor's Version)",
        album_num: 6,
        song: "Come Back... Be Here (Taylor's Version)",
        line: {
          prev: "Spinning faster than the plane that took you",
          this: "And this is when the feeling sinks in",
          next: "I don't wanna miss you like this",
          num: 10,
          section: "[Chorus]",
        },
      },
      {
        album: "evermore",
        album_num: 1,
        song: "long story short",
        line: {
          prev: "Pushed from the precipice",
          this: "Clung to the nearest lips",
          next: "Long story short, it was the wrong guy",
          num: 32,
          section: "[Chorus]",
        },
      },
    ],
    [
      {
        album: "Fearless (Taylor's Version)",
        album_num: 8,
        song: "Tell Me Why (Taylor's Version)",
        line: {
          prev: "Here's to you and your temper",
          this: "Yes, I remember what you said last night",
          next: "And I know that you see what you're doin' to me",
          num: 26,
          section: "[Chorus]",
        },
      },
      {
        album: "Taylor Swift",
        album_num: 9,
        song: "Cold As You",
        line: {
          prev: "You put up walls and paint them all a shade of gray",
          this: "And I stood there loving you and wished them all away",
          next: "And you come away with a great little story",
          num: 10,
          section: "[Verse 2]",
        },
      },
      {
        album: "folklore",
        album_num: 2,
        song: "august",
        line: {
          prev: "And I can see us twisted in bedsheets",
          this: "August sipped away like a bottle of wine",
          next: "'Cause you were never mine",
          num: 19,
          section: "[Chorus]",
        },
      },
      {
        album: "Fearless (Taylor's Version)",
        album_num: 8,
        song: "Forever & Always (Piano Version) (Taylor's Version)",
        line: {
          prev: "You didn't mean it baby, I don't think so",
          this: "Oh, oh-oh, oh-oh-oh",
          next: "Oh-oh, oh-oh-oh",
          num: 37,
          section: "[Bridge]",
        },
      },
      {
        album: "Speak Now",
        album_num: 7,
        song: "Enchanted",
        line: {
          prev: "I wonder 'til I'm wide awake",
          this: "And now I'm pacing back and forth",
          next: "Wishing you were at my door",
          num: 25,
          section: "[Verse 3]",
        },
      },
      {
        album: "folklore",
        album_num: 2,
        song: "illicit affairs",
        line: {
          prev: "Like you don't even exist",
          this: "Take the words for what they are",
          next: "A dwindling, mercurial high",
          num: 18,
          section: "[Verse 2]",
        },
      },
      {
        album: "Taylor Swift",
        album_num: 9,
        song: "Teardrops On My Guitar",
        line: {
          prev: "He's the reason for the teardrops on my guitar",
          this: "The only thing that keeps me wishing on a wishing star",
          next: "He's the song in the car",
          num: 24,
          section: "[Chorus]",
        },
      },
      {
        album: "Lover",
        album_num: 3,
        song: "The Man",
        line: {
          prev: "I'd be a fearless leader",
          this: "I'd be an alpha type",
          next: "When everyone believes ya",
          num: 6,
          section: "[Pre-Chorus]",
        },
      },
      {
        album: "Red (Taylor's Version)",
        album_num: 6,
        song: "All Too Well (Taylor's Version)",
        line: {
          prev: "There was nothing else I could do",
          this: "And I forget about you long enough",
          next: "To forget why I needed to",
          num: 23,
          section: "[Pre-Chorus]",
        },
      },
      {
        album: "evermore",
        album_num: 1,
        song: "marjorie",
        line: {
          prev: "You forget to be clever",
          this: "Never be so clever",
          next: "You forget to be kind",
          num: 3,
          section: "[Verse 1]",
        },
      },
      {
        album: "evermore",
        album_num: 1,
        song: "it's time to go",
        line: {
          prev: "That will find you the right thing",
          this: "Sometimes giving up is the strong thing",
          next: "Sometimes to run is the brave thing",
          num: 42,
          section: "[Post-Chorus]",
        },
      },
      {
        album: "Taylor Swift",
        album_num: 9,
        song: "Mary's Song (Oh My My My)",
        line: {
          prev: "Take me back to the house in the backyard tree",
          this: "Said you'd beat me up, you were bigger than me",
          next: "You never did, you never did",
          num: 8,
          section: "[Chorus 1]",
        },
      },
      {
        album: "1989",
        album_num: 5,
        song: "I Wish You Would",
        line: {
          prev: "And remember what we were fighting for, and I",
          this: "Wish you knew that",
          next: "I miss you too much to be mad anymore, and I",
          num: 61,
          section: "[Chorus 2]",
        },
      },
    ],
    [
      {
        album: "Unspecified Album",
        album_num: 10,
        song: "Two Is Better Than One",
        line: {
          prev: "And maybe two is better than one",
          this: "But there's so much time to figure out the rest of my life",
          next: "And you've already got me coming undone",
          num: 20,
          section: "[Chorus: Boys Like Girls & Taylor Swift]",
        },
      },
      {
        album: "Fearless (Taylor's Version)",
        album_num: 8,
        song: "Superstar (Taylor's Version)",
        line: {
          prev: "So dim that spotlight, tell me things like",
          this: "I can't take my eyes off of you",
          next: "I'm no one special, just another wide-eyed girl",
          num: 23,
          section: "[Chorus]",
        },
      },
      {
        album: "Reputation",
        album_num: 4,
        song: "This Is Why We Can't Have Nice Things",
        line: {
          prev: "(And here's to my real friends)",
          this: "Because you break them",
          next: "I had to take them",
          num: 46,
          section: "[Chorus]",
        },
      },
      {
        album: "Taylor Swift",
        album_num: 9,
        song: "A Perfectly Good Heart",
        line: {
          prev: "Should've read the writing on the wall",
          this: "And realized by the distance in your eyes that I would be the one to fall",
          next: "No matter what you say, I still can't believe",
          num: 7,
          section: "[Verse]",
        },
      },
      {
        album: "Red (Taylor's Version)",
        album_num: 6,
        song: "The Lucky One (Taylor's Version)",
        line: {
          prev: "Yeah, they'll tell you now, you're the lucky one",
          this: "But can you tell me now, you're the lucky one?",
          next: "Oh, oh, oh",
          num: 11,
          section: "[Chorus 1]",
        },
      },
      {
        album: "Red (Taylor's Version)",
        album_num: 6,
        song: "State Of Grace (Acoustic Version) (Taylor's Version)",
        line: {
          prev: "You come around and the armor falls",
          this: "Pierce the room like a cannonball",
          next: "Now all we know is don't let go",
          num: 12,
          section: "[Verse 2]",
        },
      },
      {
        album: "evermore",
        album_num: 1,
        song: "'tis the damn season",
        line: {
          prev: "To leave the warmest bed I've ever known",
          this: "We could call it even",
          next: "Even though I'm leaving",
          num: 38,
          section: "[Bridge]",
        },
      },
      {
        album: "1989",
        album_num: 5,
        song: "Welcome To New York",
        line: {
          prev: "Welcome to New York, welcome to New York",
          this: "When we first dropped our bags on apartment floors",
          next: "Took our broken hearts, put them in a drawer",
          num: 14,
          section: "[Verse 2]",
        },
      },
      {
        album: "evermore",
        album_num: 1,
        song: "closure",
        line: {
          prev: "Closure, your closure",
          this: "Your closure, your closure",
          next: "I know I'm just a wrinkle in your new life",
          num: 26,
          section: "[Chorus]",
        },
      },
      {
        album: "Fearless (Taylor's Version)",
        album_num: 8,
        song: "You're Not Sorry (Taylor's Version)",
        line: {
          prev: "You're not sorry",
          this: "No, no, oh-oh",
          next: "No, no, no, no, no, no, no, no, no, no, no, no",
          num: 41,
          section: "[Chorus]",
        },
      },
      {
        album: "Lover",
        album_num: 3,
        song: "The Man",
        line: {
          prev: "So, it's okay that I'm mad",
          this: "I'm so sick of running as fast as I can",
          next: "Wondering if I'd get there quicker if I was a man (You know that)",
          num: 35,
          section: "[Chorus]",
        },
      },
      {
        album: "1989",
        album_num: 5,
        song: "Bad Blood",
        line: {
          prev: "You know it used to be mad love",
          this: "So take a look what you've done (Look what you've done)",
          next: "'Cause baby, now we've got bad blood, hey!",
          num: 65,
          section: "[Chorus]",
        },
      },
      {
        album: "1989",
        album_num: 5,
        song: "I Know Places",
        line: {
          prev: "And you know for me, it's always you (I know places)",
          this: "In the dead of night, your eyes so green (I know places)",
          next: "And I know for you, it's always me (I know places)",
          num: 36,
          section: "[Outro]",
        },
      },
    ],
    [
      {
        album: "Red (Taylor's Version)",
        album_num: 6,
        song: "I Knew You Were Trouble (Taylor's Version)",
        line: {
          prev: "So shame on me now",
          this: "Flew me to places I'd never been",
          next: "'Til you put me down, oh",
          num: 11,
          section: "[Chorus]",
        },
      },
      {
        album: "Speak Now",
        album_num: 7,
        song: "Never Grow Up",
        line: {
          prev: "I just realized everything I have is someday gonna be gone",
          this: "So here I am in my new apartment",
          next: "In a big city, they just dropped me off",
          num: 33,
          section: "[Bridge]",
        },
      },
      {
        album: "Taylor Swift",
        album_num: 9,
        song: "Tied Together With A Smile",
        line: {
          prev: "But you're coming undone",
          this: "I guess it's true that love was all you wanted",
          next: "'Cause you're giving it away like it's extra change",
          num: 12,
          section: "[Verse 2]",
        },
      },
      {
        album: "Red (Taylor's Version)",
        album_num: 6,
        song: "Begin Again (Taylor's Version)",
        line: {
          prev: "I've been spending the last eight months",
          this: "Thinking all love ever does is break and burn and end",
          next: "But on a Wednesday in a cafe, I watched it begin again",
          num: 13,
          section: "[Chorus]",
        },
      },
      {
        album: "Reputation",
        album_num: 4,
        song: "I Did Something Bad",
        line: {
          prev: "Now all he thinks about is me",
          this: "I can feel the flames on my skin",
          next: "Crimson red paint on my lips",
          num: 7,
          section: "[Pre-Chorus 1]",
        },
      },
      {
        album: "Taylor Swift",
        album_num: 9,
        song: "Invisible",
        line: {
          prev: "No matter what you do",
          this: "And all I think about is how to make you think of me",
          next: "And everything that we could be",
          num: 21,
          section: "[Pre-Chorus]",
        },
      },
      {
        album: "evermore",
        album_num: 1,
        song: "'tis the damn season",
        line: {
          prev: "We could just ride around",
          this: "And the road not taken looks real good now",
          next: "And it always leads to you and my hometown",
          num: 28,
          section: "[Chorus]",
        },
      },
      {
        album: "Lover",
        album_num: 3,
        song: "Death By A Thousand Cuts",
        line: {
          prev: "Flashbacks waking me up",
          this: "I get drunk, but it's not enough",
          next: "'Cause the morning comes and you're not my baby",
          num: 28,
          section: "[Chorus]",
        },
      },
      {
        album: "Reputation",
        album_num: 4,
        song: "Dress",
        line: {
          prev: "My hands shake, I can't explain this",
          this: "Ah, ha, ha, ha-ah",
          next: "Say my name and everything just stops...",
          num: 55,
          section: "[Bridge]",
        },
      },
      {
        album: "1989",
        album_num: 5,
        song: "Wonderland",
        line: {
          prev: "We found Wonderland",
          this: "You and I got lost in it (Got lost in it)",
          next: "And life was never worse but never better",
          num: 66,
          section: "[Chorus]",
        },
      },
      {
        album: "folklore",
        album_num: 2,
        song: "epiphany",
        line: {
          prev: "Only twenty minutes to sleep",
          this: "But you dream of some epiphany",
          next: "Just one single glimpse of relief",
          num: 14,
          section: "[Bridge]",
        },
      },
      {
        album: "Unspecified Album",
        album_num: 10,
        song: "Two Is Better Than One",
        line: {
          prev: "But there's so much time to figure out the rest of my life",
          this: "And you've already got me coming undone",
          next: "And I'm thinking two is better than one",
          num: 10,
          section: "[Chorus: Boys Like Girls & Taylor Swift]",
        },
      },
      {
        album: "evermore",
        album_num: 1,
        song: "no body, no crime",
        line: {
          prev: "Good thing his mistress took out a big life insurance policy",
          this: "They think she did it, but they just can't prove it",
          next: "They think she did it, but they just can't prove it",
          num: 43,
          section: "[Chorus: Taylor Swift]",
        },
      },
    ],
    [
      {
        album: "Speak Now",
        album_num: 7,
        song: "If This Was A Movie",
        line: {
          prev: "Stand in the rain outside till I came out",
          this: "Come back, come back, come back to me like",
          next: "You could, you could if you just said you're sorry",
          num: 12,
          section: "[Chorus]",
        },
      },
      {
        album: "Speak Now",
        album_num: 7,
        song: "Innocent",
        line: {
          prev: "Oh, who you are is not where you've been",
          this: "You're still an innocent",
          next: "It's okay, life is a tough crowd",
          num: 25,
          section: "[Chorus]",
        },
      },
      {
        album: "folklore",
        album_num: 2,
        song: "cardigan",
        line: {
          prev: "I knew you",
          this: "Your heartbeat on the High Line",
          next: "Once in twenty lifetimes, I",
          num: 23,
          section: "[Chorus]",
        },
      },
      {
        album: "Reputation",
        album_num: 4,
        song: "New Year's Day",
        line: {
          prev: "Whose laugh I could recognize anywhere",
          this: "Please don't ever become a stranger",
          next: "Whose laugh I could recognize anywhere",
          num: 23,
          section: "[Bridge]",
        },
      },
      {
        album: "evermore",
        album_num: 1,
        song: "right where you left me",
        line: {
          prev: "I can't bear witness",
          this: "And it's been so long",
          next: "But if you ever think you got it wrong",
          num: 51,
          section: "[Pre-Chorus]",
        },
      },
      {
        album: "Speak Now",
        album_num: 7,
        song: "Back To December",
        line: {
          prev: "I'd go back in time and change it, but I can't",
          this: "So if the chain is on your door, I understand",
          next: "But this is me swallowing my pride",
          num: 41,
          section: "[Bridge]",
        },
      },
      {
        album: "Taylor Swift",
        album_num: 9,
        song: "The Outside",
        line: {
          prev: "I can still see you, this ain't the best view",
          this: "On the outside looking in",
          next: "I've been a lot of lonely places",
          num: 11,
          section: "[Chorus]",
        },
      },
      {
        album: "folklore",
        album_num: 2,
        song: "invisible string",
        line: {
          prev: "All along there was some",
          this: "Invisible string",
          next: "Tying you to me?",
          num: 26,
          section: "[Chorus]",
        },
      },
      {
        album: "Unspecified Album",
        album_num: 10,
        song: "Two Is Better Than One",
        line: {
          prev: "But there's so much time to figure out the rest of my life",
          this: "And you've already got me coming undone",
          next: "And I'm thinking two is better than one",
          num: 21,
          section: "[Chorus: Boys Like Girls & Taylor Swift]",
        },
      },
      {
        album: "1989",
        album_num: 5,
        song: "Out Of The Woods",
        line: {
          prev: "Two paper airplanes flying, flying, flying",
          this: "And I remember thinking",
          next: "Are we out of the woods yet? Are we out of the woods yet?",
          num: 29,
          section: "[Verse 2]",
        },
      },
      {
        album: "Lover",
        album_num: 3,
        song: "The Archer",
        line: {
          prev: "But who could stay?",
          this: "Dark side, I search for your dark side",
          next: "But what if I'm alright, right, right, right here?",
          num: 12,
          section: "[Verse 2]",
        },
      },
      {
        album: "Red (Taylor's Version)",
        album_num: 6,
        song: "We Are Never Ever Getting Back Together (Taylor's Version)",
        line: {
          prev: "With some indie record that's much cooler than mine",
          this: "Ooh-ooh-ooh-ooh-ooh",
          next: "You called me up again tonight, but",
          num: 23,
          section: "[Pre-Chorus]",
        },
      },
      {
        album: "Lover",
        album_num: 3,
        song: "The Man",
        line: {
          prev: "Could all be separated from my good ideas and power moves",
          this: "And they would toast to me, oh, let the players play",
          next: "I'd be just like Leo in Saint-Tropez",
          num: 19,
          section: "[Pre-Chorus]",
        },
      },
    ],
    [
      {
        album: "Unspecified Album",
        album_num: 10,
        song: "Only The Young",
        line: {
          prev: "Wondering where the best hiding spot would be",
          this: "And the big bad man and his big bad clan",
          next: "Their hands are stained with red",
          num: 17,
          section: "[Verse 2]",
        },
      },
      {
        album: "Taylor Swift",
        album_num: 9,
        song: "Mary's Song (Oh My My My)",
        line: {
          prev: "Take me back to the time we had our very first fight",
          this: "The slamming of doors instead of kissing goodnight",
          next: "You stayed outside 'til the morning light",
          num: 24,
          section: "[Chorus 2]",
        },
      },
      {
        album: "Red (Taylor's Version)",
        album_num: 6,
        song: "Forever Winter (Taylor's Version) [From the Vault]",
        line: {
          prev: "He says, 'Why fall in love, just so you can watch it go away?'",
          this: "He spends most of his nights wishing it was how it used to be",
          next: "He spends most of his flights getting pulled down by gravity",
          num: 3,
          section: "[Verse 1]",
        },
      },
      {
        album: "Speak Now",
        album_num: 7,
        song: "Mine",
        line: {
          prev: "Do you remember all the city lights on the water?",
          this: "You saw me start to believe for the first time",
          next: "You made a rebel of a careless man's careful daughter",
          num: 27,
          section: "[Chorus]",
        },
      },
      {
        album: "Reputation",
        album_num: 4,
        song: "This Is Why We Can't Have Nice Things",
        line: {
          prev: "Nice things, honey",
          this: "(He didn't care about that he-said, she-said)",
          next: "Did you think I wouldn't hear all the things you said about me?",
          num: 50,
          section: "[Chorus]",
        },
      },
      {
        album: "folklore",
        album_num: 2,
        song: "seven",
        line: {
          prev: "Before I learned civility",
          this: "I used to scream ferociously",
          next: "Any time I wanted",
          num: 27,
          section: "[Verse 2]",
        },
      },
      {
        album: "Fearless (Taylor's Version)",
        album_num: 8,
        song: "Jump Then Fall (Taylor's Version)",
        line: {
          prev: "Well, I like the way your hair falls in your face",
          this: "You got the keys to me",
          next: "I love each freckle on your face, oh",
          num: 20,
          section: "[Verse 2]",
        },
      },
      {
        album: "1989",
        album_num: 5,
        song: "All You Had To Do Was Stay",
        line: {
          prev: "But people like me are gone forever",
          this: "When you say goodbye",
          next: "(Stay) Hey, all you had to do was stay",
          num: 31,
          section: "[Verse 2]",
        },
      },
      {
        album: "Unspecified Album",
        album_num: 10,
        song: "Both of Us",
        line: {
          prev: "Open up the fridge 'bout 20 times",
          this: "But you still can't find no food in it",
          next: "That's foolishness",
          num: 10,
          section: "[Verse 1: B.o.B]",
        },
      },
      {
        album: "Red (Taylor's Version)",
        album_num: 6,
        song: "All Too Well (Taylor's Version)",
        line: {
          prev: "'Cause I remember it all, all, all",
          this: "Too well",
          next: "Time won't fly, it's like I'm paralyzed by it",
          num: 40,
          section: "[Bridge]",
        },
      },
      {
        album: "evermore",
        album_num: 1,
        song: "right where you left me",
        line: {
          prev: "Cross-legged in the dim light",
          this: "They say, 'What a sad sight'",
          next: "I, I swear you could hear a hair pin drop",
          num: 12,
          section: "[Pre-Chorus]",
        },
      },
      {
        album: "Unspecified Album",
        album_num: 10,
        song: "Beautiful Ghosts",
        line: {
          prev: "But at least you have beautiful ghosts",
          this: "And so maybe my home isn't what I had known",
          next: "What I thought it would be",
          num: 25,
          section: "[Bridge]",
        },
      },
      {
        album: "evermore",
        album_num: 1,
        song: "long story short",
        line: {
          prev: "Pushed from the precipice",
          this: "Clung to the nearest lips",
          next: "Long story short, it was the wrong guy",
          num: 13,
          section: "[Chorus]",
        },
      },
    ],
    [
      {
        album: "Reputation",
        album_num: 4,
        song: "Dress",
        line: {
          prev: "Ah, ha, ha, ha-ah",
          this: "Say my name and everything just stops",
          next: "I don't want you like a best friend",
          num: 11,
          section: "[Chorus]",
        },
      },
      {
        album: "folklore",
        album_num: 2,
        song: "invisible string",
        line: {
          prev: "She said I looked like an American singer",
          this: "Time, mystical time",
          next: "Cutting me open, then healing me fine",
          num: 21,
          section: "[Chorus]",
        },
      },
      {
        album: "evermore",
        album_num: 1,
        song: "gold rush",
        line: {
          prev: "Gleaming, twinkling",
          this: "Eyes like sinking ships on waters",
          next: "So inviting, I almost jump in",
          num: 41,
          section: "[Outro]",
        },
      },
      {
        album: "folklore",
        album_num: 2,
        song: "the lakes",
        line: {
          prev: "And I want you right here",
          this: "A red rose grew up out of ice frozen ground",
          next: "With no one around to tweet it",
          num: 20,
          section: "[Bridge]",
        },
      },
      {
        album: "Red (Taylor's Version)",
        album_num: 6,
        song: "Girl At Home (Taylor's Version)",
        line: {
          prev: "This, I have previously learned",
          this: "So don't look at me, you got a girl at home",
          next: "And everybody knows that, everybody knows that, ah-ah",
          num: 14,
          section: "[Chorus]",
        },
      },
      {
        album: "folklore",
        album_num: 2,
        song: "the 1",
        line: {
          prev: "(Ooh)",
          this: "I have this dream you're doing cool shit",
          next: "Having adventures on your own",
          num: 20,
          section: "[Verse 2]",
        },
      },
      {
        album: "1989",
        album_num: 5,
        song: "I Know Places",
        line: {
          prev: "Baby, I know places we won't be found",
          this: "And they'll be chasing their tails trying to track us down",
          next: "'Cause I, I know places we can hide",
          num: 15,
          section: "[Chorus]",
        },
      },
      {
        album: "Taylor Swift",
        album_num: 9,
        song: "A Perfectly Good Heart",
        line: {
          prev: "No matter what you say, I still can't believe",
          this: "That you would walk away",
          next: "It don't make sense to me, but",
          num: 9,
          section: "[Verse]",
        },
      },
      {
        album: "Red (Taylor's Version)",
        album_num: 6,
        song: "Message In A Bottle (Taylor's Version) [From the Vault]",
        line: {
          prev: "These days I'm restless",
          this: "Workdays are endless, look how you made me, made me",
          next: "But time moves faster, replaying your laughter, disaster",
          num: 16,
          section: "[Verse 2]",
        },
      },
      {
        album: "Red (Taylor's Version)",
        album_num: 6,
        song: "Stay Stay Stay (Taylor's Version)",
        line: {
          prev: "That's when you came in wearing a football helmet",
          this: "And said, 'Okay, let's talk'",
          next: "And I said",
          num: 8,
          section: "[Verse 1]",
        },
      },
      {
        album: "Speak Now",
        album_num: 7,
        song: "Back To December",
        line: {
          prev: "Probably mindless dreaming",
          this: "But if we loved again, I swear I'd love you right",
          next: "I'd go back in time and change it, but I can't",
          num: 39,
          section: "[Bridge]",
        },
      },
      {
        album: "Fearless (Taylor's Version)",
        album_num: 8,
        song: "Mr. Perfectly Fine (Taylor's Version) [From The Vault]",
        line: {
          prev: "Hello, Mr. 'Perfectly fine'",
          this: "How's your heart after breakin' mine?",
          next: "Mr. 'Always at the right place at the right time,' baby",
          num: 12,
          section: "[Chorus]",
        },
      },
      {
        album: "Lover",
        album_num: 3,
        song: "It's Nice To Have A Friend",
        line: {
          prev: "Ooh",
          this: "School bell rings, walk me home",
          next: "Sidewalk chalk covered in snow",
          num: 3,
          section: "[Verse 1]",
        },
      },
    ],
    [
      {
        album: "Fearless (Taylor's Version)",
        album_num: 8,
        song: "Bye Bye Baby (Taylor's Version) [From The Vault]",
        line: {
          prev: "'Cause you took me home but you just couldn't keep me",
          this: "Oh, you took me home, I thought you were gonna keep me",
          next: "Bye bye baby",
          num: 43,
          section: "[Chorus]",
        },
      },
      {
        album: "Taylor Swift",
        album_num: 9,
        song: "Cold As You",
        line: {
          prev: "Oh, what a shame, what a rainy ending given to a perfect day",
          this: "Every smile you fake is so condescending",
          next: "Counting all the scars you made",
          num: 21,
          section: "[Chorus]",
        },
      },
      {
        album: "Taylor Swift",
        album_num: 9,
        song: "Should've Said No",
        line: {
          prev: "You should've gone home",
          this: "You should've thought twice 'fore you let it all go",
          next: "You should've known that word, 'bout what you did with her'd",
          num: 38,
          section: "[Chorus]",
        },
      },
      {
        album: "Reputation",
        album_num: 4,
        song: "End Game",
        line: {
          prev: "I wanna be your A-Team (A-Team)",
          this: "I wanna be your end game, end game",
          next: "Big reputation, big reputation",
          num: 56,
          section: "[Chorus: Taylor Swift]",
        },
      },
      {
        album: "Lover",
        album_num: 3,
        song: "Cruel Summer",
        line: {
          prev: "And I snuck in through the garden gate",
          this: "Every night that summer just to seal my fate (Oh)",
          next: "And I scream, 'For whatever it's worth",
          num: 41,
          section: "[Bridge]",
        },
      },
      {
        album: "Reputation",
        album_num: 4,
        song: "King Of My Heart",
        line: {
          prev: "King of my heart, body, and soul, ooh whoa",
          this: "And all at once, I've been waiting, waiting",
          next: "Ooh whoa, ooh whoa",
          num: 15,
          section: "[Post-Chorus]",
        },
      },
      {
        album: "Unspecified Album",
        album_num: 10,
        song: "Renegade",
        line: {
          prev: "The shape of you was jagged and weak",
          this: "There was nowhere for me to stay, but I stayed anyway",
          next: "You fire off missiles 'cause you hate yourself",
          num: 17,
          section: "[Verse 2: Taylor Swift]",
        },
      },
      {
        album: "folklore",
        album_num: 2,
        song: "betty",
        line: {
          prev: "I'm only seventeen, I don't know anything",
          this: "But I know I miss you",
          next: "Standing in your cardigan",
          num: 63,
          section: "[Chorus]",
        },
      },
      {
        album: "folklore",
        album_num: 2,
        song: "epiphany",
        line: {
          prev: "Crawling up the beaches now",
          this: "'Sir, I think he's bleeding out'",
          next: "And some things you just can't speak about",
          num: 4,
          section: "[Verse 1]",
        },
      },
      {
        album: "1989",
        album_num: 5,
        song: "I Wish You Would",
        line: {
          prev: "I, I, I, I, I, I wish I, wish I",
          this: "I, I, I, I, I, I wish I, wish I",
          next: "You always knew how to push my buttons",
          num: 32,
          section: "[Post-Chorus]",
        },
      },
      {
        album: "evermore",
        album_num: 1,
        song: "no body, no crime",
        line: {
          prev: "She thinks I did it, but she just can't prove it",
          this: "No, no body, no crime",
          next: "I wasn't lettin' up until the day he-",
          num: 46,
          section: "[Outro: Taylor Swift & HAIM]",
        },
      },
      {
        album: "Fearless (Taylor's Version)",
        album_num: 8,
        song: "We Were Happy (Taylor's Version) [From The Vault]",
        line: {
          prev: "Oh, I hate those voices telling me I'm not in love anymore",
          this: "But they don't give me choices and that's what these tears are for",
          next: "'Cause we were happy",
          num: 23,
          section: "[Bridge]",
        },
      },
      {
        album: "1989",
        album_num: 5,
        song: "Out Of The Woods",
        line: {
          prev: "It all seems so simple",
          this: "We were lying on your couch",
          next: "I remember",
          num: 3,
          section: "[Verse 1]",
        },
      },
    ],
    [
      {
        album: "Fearless (Taylor's Version)",
        album_num: 8,
        song: "Bye Bye Baby (Taylor's Version) [From The Vault]",
        line: {
          prev: "Bye bye baby",
          this: "And there's so much that I can't touch",
          next: "You're all I want but it's not enough this time",
          num: 29,
          section: "[Bridge]",
        },
      },
      {
        album: "Speak Now",
        album_num: 7,
        song: "Superman",
        line: {
          prev: "I loved you from the very first day",
          this: "I watch superman fly away",
          next: "You've got a busy day today",
          num: 28,
          section: "[Chorus]",
        },
      },
      {
        album: "Unspecified Album",
        album_num: 10,
        song: "I Don't Wanna Live Forever",
        line: {
          prev: "Now I'm in a cab, I tell 'em where your place is",
          this: "What is happening to me?",
          next: "I don't wanna live forever, 'cause I know I'll be living in vain",
          num: 30,
          section: "[Bridge: Taylor Swift, ZAYN & Both]",
        },
      },
      {
        album: "Lover",
        album_num: 3,
        song: "Daylight",
        line: {
          prev: "I only see daylight, daylight, daylight, daylight",
          this: "I only see daylight, daylight, daylight, daylight",
          next: "And I can still see it all (In my mind)",
          num: 25,
          section: "[Chorus]",
        },
      },
      {
        album: "Red (Taylor's Version)",
        album_num: 6,
        song: "All Too Well (Taylor's Version)",
        line: {
          prev: "I'm a crumpled up piece of paper lying here",
          this: "'Cause I remember it all, all, all",
          next: "Too well",
          num: 39,
          section: "[Bridge]",
        },
      },
      {
        album: "Unspecified Album",
        album_num: 10,
        song: "Crazier",
        line: {
          prev: "Baby you showed me what living is for",
          this: "I don't want to hide anymore",
          next: "Oh oh",
          num: 28,
          section: "[Bridge]",
        },
      },
      {
        album: "Fearless (Taylor's Version)",
        album_num: 8,
        song: "You All Over Me (Taylor's Version) [From The Vault]",
        line: {
          prev: "I've still got you all over me",
          this: "The best and worst day of June",
          next: "Was the one that I met you",
          num: 15,
          section: "[Verse 2: Taylor Swift, with Maren Morris]",
        },
      },
      {
        album: "1989",
        album_num: 5,
        song: "All You Had To Do Was Stay",
        line: {
          prev: "(Stay) Hey, all you had to do was stay",
          this: "Had me in the palm of your hand, then",
          next: "Why'd you have to go and lock me out when I let you in?",
          num: 33,
          section: "[Chorus]",
        },
      },
      {
        album: "Reputation",
        album_num: 4,
        song: "Don't Blame Me",
        line: {
          prev: "Something happened for the first time",
          this: "In the darkest little paradise",
          next: "Shakin', pacin', I just need you",
          num: 9,
          section: "[Verse 1]",
        },
      },
      {
        album: "folklore",
        album_num: 2,
        song: "peace",
        line: {
          prev: "Would it be enough if I could never give you peace?",
          this: "Would it be enough if I could never give you peace?",
          next: "Would it be enough if I could never give you peace?",
          num: 32,
          section: "[Chorus]",
        },
      },
      {
        album: "Fearless (Taylor's Version)",
        album_num: 8,
        song: "Love Story (Taylor's Version)",
        line: {
          prev: "And my daddy said, 'Stay away from Juliet'",
          this: "And I was crying on the staircase",
          next: "Begging you, 'Please don't go,' and I said",
          num: 11,
          section: "[Pre-Chorus]",
        },
      },
      {
        album: "Taylor Swift",
        album_num: 9,
        song: "Should've Said No",
        line: {
          prev: "You shouldn't be begging for forgiveness at my feet",
          this: "You should've said no, baby, and you might still have me",
          next: "",
          num: 44,
          section: "[Chorus]",
        },
      },
      {
        album: "folklore",
        album_num: 2,
        song: "my tears ricochet",
        line: {
          prev: "We gather here, we line up, weepin' in a sunlit room",
          this: "And if I'm on fire, you'll be made of ashes, too",
          next: "Even on my worst day, did I deserve, babe",
          num: 2,
          section: "[Verse 1]",
        },
      },
    ],
    [
      {
        album: "Red (Taylor's Version)",
        album_num: 6,
        song: "Message In A Bottle (Taylor's Version) [From the Vault]",
        line: {
          prev: "I could be the reason you can't sleep at night (At night)",
          this: "A message in a bottle is all I can do",
          next: "Standin' here, hopin' it gets to you",
          num: 27,
          section: "[Chorus]",
        },
      },
      {
        album: "Fearless (Taylor's Version)",
        album_num: 8,
        song: "We Were Happy (Taylor's Version) [From The Vault]",
        line: {
          prev: "I do recall a good while back, we snuck into the circus",
          this: "You threw your arms around my neck, back when I deserved it",
          next: "And we were happy",
          num: 6,
          section: "[Verse 1]",
        },
      },
      {
        album: "Speak Now",
        album_num: 7,
        song: "Haunted",
        line: {
          prev: "Something's gone terribly wrong",
          this: "You're all I wanted",
          next: "Come on, come on, don't leave me like this",
          num: 30,
          section: "[Chorus]",
        },
      },
      {
        album: "evermore",
        album_num: 1,
        song: "long story short",
        line: {
          prev: "I wanna tell you not to get lost in these petty things",
          this: "Your nemeses",
          next: "Will defeat themselves before you get the chance to swing",
          num: 48,
          section: "[Verse 3]",
        },
      },
      {
        album: "Red (Taylor's Version)",
        album_num: 6,
        song: "Holy Ground (Taylor's Version)",
        line: {
          prev: "Was holy ground",
          this: "Spinning like a girl in a brand new dress",
          next: "We had this big wide city all to ourselves",
          num: 13,
          section: "[Verse 2]",
        },
      },
      {
        album: "1989",
        album_num: 5,
        song: "Clean",
        line: {
          prev: "Now that I'm clean, I'm never gonna risk it",
          this: "The drought was the very worst (Oh-oh, oh-oh)",
          next: "When the flowers that we'd grown together died of thirst",
          num: 35,
          section: "[Breakdown]",
        },
      },
      {
        album: "Fearless (Taylor's Version)",
        album_num: 8,
        song: "You All Over Me (Taylor's Version) [From The Vault]",
        line: {
          prev: "Was the one that I met you",
          this: "With your hands in your pockets",
          next: "And your 'Don't you wish you had me?' grin",
          num: 17,
          section: "[Verse 2: Taylor Swift, with Maren Morris]",
        },
      },
      {
        album: "Speak Now",
        album_num: 7,
        song: "Speak Now",
        line: {
          prev: "Ooh, ooh",
          this: "(Say a single vow)",
          next: "I hear the preacher say",
          num: 46,
          section: "[Interlude]",
        },
      },
      {
        album: "Lover",
        album_num: 3,
        song: "False God",
        line: {
          prev: "Got the wine for you",
          this: "And you can't talk to me when I'm like this",
          next: "Daring you to leave me just so I can try and scare you",
          num: 30,
          section: "[Pre-Chorus]",
        },
      },
      {
        album: "1989",
        album_num: 5,
        song: "Welcome To New York",
        line: {
          prev: "So bright, they never blind me",
          this: "Welcome to New York",
          next: "Welcome to New York",
          num: 43,
          section: "[Chorus]",
        },
      },
      {
        album: "folklore",
        album_num: 2,
        song: "epiphany",
        line: {
          prev: "'Doc, I think she's crashing out'",
          this: "And some things you just can't speak about",
          next: "Only twenty minutes to sleep",
          num: 12,
          section: "[Verse 2]",
        },
      },
      {
        album: "Reputation",
        album_num: 4,
        song: "Delicate",
        line: {
          prev: "Isn't it? Isn't it? Isn't it?",
          this: "Isn't it... delicate?",
          next: "Third floor on the West Side, me and you",
          num: 30,
          section: "[Chorus]",
        },
      },
      {
        album: "Lover",
        album_num: 3,
        song: "Cruel Summer",
        line: {
          prev: "It's a cruel summer",
          this: "It's cool, that's what I tell 'em",
          next: "No rules in breakable heaven",
          num: 14,
          section: "[Chorus]",
        },
      },
    ],
    [
      {
        album: "1989",
        album_num: 5,
        song: "Bad Blood",
        line: {
          prev: "'Cause baby, now we've got bad blood",
          this: "You know it used to be mad love",
          next: "So take a look what you've done",
          num: 2,
          section: "[Chorus]",
        },
      },
      {
        album: "Red (Taylor's Version)",
        album_num: 6,
        song: "The Moment I Knew (Taylor's Version)",
        line: {
          prev: "You called me later",
          this: "And said, 'I'm sorry I didn't make it'",
          next: "And I said, 'I'm sorry, too'",
          num: 60,
          section: "[Outro]",
        },
      },
      {
        album: "Speak Now",
        album_num: 7,
        song: "Superman",
        line: {
          prev: "Wishing the card was from you",
          this: "Wishing the call was from you",
          next: "'Cause I loved you from the very first day",
          num: 43,
          section: "[Breakdown]",
        },
      },
      {
        album: "Taylor Swift",
        album_num: 9,
        song: "Stay Beautiful",
        line: {
          prev: "Ask anyone",
          this: "And when you find everything you looked for",
          next: "I hope your life will lead you back to my door",
          num: 12,
          section: "[Chorus]",
        },
      },
      {
        album: "folklore",
        album_num: 2,
        song: "my tears ricochet",
        line: {
          prev: "But what a ghostly scene",
          this: "You wear the same jewels that I gave you",
          next: "As you bury me",
          num: 16,
          section: "[Verse 2]",
        },
      },
      {
        album: "Unspecified Album",
        album_num: 10,
        song: "Renegade",
        line: {
          prev: "I might've let them lay",
          this: "Are you really gonna talk about timing in times like these?",
          next: "And let all your damage damage me",
          num: 33,
          section: "[Chorus: Taylor Swift & Justin Vernon]",
        },
      },
      {
        album: "Fearless (Taylor's Version)",
        album_num: 8,
        song: "Don't You (Taylor's Version) [From The Vault]",
        line: {
          prev: "You don't know how much I feel I love you still",
          this: "So why don't you, don't you?",
          next: "Ah, ah, ah, ah",
          num: 10,
          section: "[Chorus]",
        },
      },
      {
        album: "Fearless (Taylor's Version)",
        album_num: 8,
        song: "Untouchable (Taylor's Version)",
        line: {
          prev: "You got to come on, come on, say that we'll be together",
          this: "Come on, come on, little taste of heaven",
          next: "Oh, oh-oh-oh, oh-oh-oh, oh",
          num: 37,
          section: "[Chorus]",
        },
      },
      {
        album: "Red (Taylor's Version)",
        album_num: 6,
        song: "Nothing New (Taylor's Version) [From the Vault]",
        line: {
          prev: "They tell you while you're young",
          this: "'Girls, go out and have your fun'",
          next: "Then they hunt and slay the ones who actually do it",
          num: 2,
          section: "[Verse 1: Taylor Swift]",
        },
      },
      {
        album: "Red (Taylor's Version)",
        album_num: 6,
        song: "Starlight (Taylor's Version)",
        line: {
          prev: "Oh, my, what a marvelous tune",
          this: "It was the best night, never would forget how we moved",
          next: "The whole place was dressed to the nines",
          num: 37,
          section: "[Chorus]",
        },
      },
      {
        album: "evermore",
        album_num: 1,
        song: "closure",
        line: {
          prev: "Some situation that needs to be handled",
          this: "I'm fine with my spite",
          next: "And my tears, and my beers and my candles",
          num: 16,
          section: "[Verse 2]",
        },
      },
      {
        album: "evermore",
        album_num: 1,
        song: "happiness",
        line: {
          prev: "Past the blood and bruise",
          this: "Past the curses and cries",
          next: "Beyond the terror in the nightfall",
          num: 14,
          section: "[Post-Chorus]",
        },
      },
      {
        album: "1989",
        album_num: 5,
        song: "Bad Blood",
        line: {
          prev: "And I don't think we can solve 'em",
          this: "You made a really deep cut",
          next: "And baby, now we've got bad blood, hey!",
          num: 26,
          section: "[Chorus]",
        },
      },
    ],
    [
      {
        album: "Taylor Swift",
        album_num: 9,
        song: "Should've Said No",
        line: {
          prev: "But do you honestly expect me to believe",
          this: "We could ever be the same?",
          next: "You say that the past is the past, you need one chance",
          num: 19,
          section: "[Verse 2]",
        },
      },
      {
        album: "Fearless (Taylor's Version)",
        album_num: 8,
        song: "Superstar (Taylor's Version)",
        line: {
          prev: "I can't keep my eyes off of you",
          this: "I'm no one special, just another wide-eyed girl",
          next: "Who's desperately in love with you",
          num: 11,
          section: "[Chorus]",
        },
      },
      {
        album: "Red (Taylor's Version)",
        album_num: 6,
        song: "Holy Ground (Taylor's Version)",
        line: {
          prev: "And the story's got dust on every page",
          this: "But sometimes, I wonder how you think about it now",
          next: "And I see your face in every crowd",
          num: 19,
          section: "[Verse 2]",
        },
      },
      {
        album: "Speak Now",
        album_num: 7,
        song: "Mean",
        line: {
          prev: "And all you're ever gonna be is mean",
          this: "Someday, I'll be big enough so you can't hit me",
          next: "And all you're ever gonna be is mean",
          num: 30,
          section: "[Chorus]",
        },
      },
      {
        album: "Lover",
        album_num: 3,
        song: "I Think He Knows",
        line: {
          prev: "Lyrical smile, indigo eyes, hand on my thigh",
          this: "We could follow the sparks, I'll drive",
          next: "Lyrical smile, indigo eyes, hand on my thigh",
          num: 44,
          section: "[Bridge]",
        },
      },
      {
        album: "Taylor Swift",
        album_num: 9,
        song: "Mary's Song (Oh My My My)",
        line: {
          prev: "You said 'I do' and I did too",
          this: "Take me home where we met so many years before",
          next: "We'll rock our babies on that very front porch",
          num: 33,
          section: "[Chorus 3]",
        },
      },
      {
        album: "Lover",
        album_num: 3,
        song: "I Forgot That You Existed",
        line: {
          prev: "Would've been right there, front row",
          this: "Even if nobody came to your show",
          next: "But you showed who you are, then one magical night",
          num: 24,
          section: "[Verse 2]",
        },
      },
      {
        album: "evermore",
        album_num: 1,
        song: "'tis the damn season",
        line: {
          prev: "We could just ride around",
          this: "And the road not taken looks real good now",
          next: "And it always leads to you and my hometown",
          num: 28,
          section: "[Chorus]",
        },
      },
      {
        album: "Fearless (Taylor's Version)",
        album_num: 8,
        song: "Hey Stephen (Taylor's Version)",
        line: {
          prev: "Why aren't you here tonight?",
          this: "I'm waiting alone now, so come on and come out",
          next: "And pull me near and shine, shine, shine",
          num: 32,
          section: "[Bridge]",
        },
      },
      {
        album: "Lover",
        album_num: 3,
        song: "Soon You'll Get Better",
        line: {
          prev: "You'll get better",
          this: "Ooh-ah",
          next: "Soon, you'll get better",
          num: 36,
          section: "[Chorus: Taylor Swift & The Chicks]",
        },
      },
      {
        album: "1989",
        album_num: 5,
        song: "Style",
        line: {
          prev: "And I got that red lip classic thing that you like",
          this: "And when we go crashing down, we come back every time",
          next: "'Cause we never go out of style, we never go out of style",
          num: 31,
          section: "[Chorus]",
        },
      },
      {
        album: "Taylor Swift",
        album_num: 9,
        song: "Teardrops On My Guitar",
        line: {
          prev: "Drew talks to me",
          this: "I laugh 'cause it's so damn funny",
          next: "That I can't even see",
          num: 8,
          section: "[Verse 2]",
        },
      },
      {
        album: "Lover",
        album_num: 3,
        song: "I Think He Knows",
        line: {
          prev: "I think he knows",
          this: "He'd better lock it down",
          next: "Or I won't stick around",
          num: 25,
          section: "[Verse 2]",
        },
      },
    ],
    [
      {
        album: "folklore",
        album_num: 2,
        song: "exile",
        line: {
          prev: "And it took you five whole minutes",
          this: "To pack us up and leave me with it",
          next: "Holdin' all this love out here in the hall",
          num: 5,
          section: "[Verse 1: Justin Vernon]",
        },
      },
      {
        album: "1989",
        album_num: 5,
        song: "Blank Space",
        line: {
          prev: "You look like my next mistake",
          this: "Love's a game, wanna play?'",
          next: "Ayy",
          num: 7,
          section: "[Verse 1]",
        },
      },
      {
        album: "evermore",
        album_num: 1,
        song: "happiness",
        line: {
          prev: "There is a glorious sunrise",
          this: "Dappled with the flickers of light",
          next: "From the dress I wore at midnight, leave it all behind",
          num: 59,
          section: "[Post-Chorus]",
        },
      },
      {
        album: "folklore",
        album_num: 2,
        song: "invisible string",
        line: {
          prev: "When you were sixteen at the yogurt shop",
          this: "You used to work at to make a little money",
          next: "Time, curious time",
          num: 6,
          section: "[Verse 1]",
        },
      },
      {
        album: "Taylor Swift",
        album_num: 9,
        song: "Mary's Song (Oh My My My)",
        line: {
          prev: "Well, I was sixteen when suddenly",
          this: "I wasn't that little girl you used to see",
          next: "But your eyes still shined like pretty lights",
          num: 15,
          section: "[Verse 2]",
        },
      },
      {
        album: "Lover",
        album_num: 3,
        song: "I Think He Knows",
        line: {
          prev: "I want you, bless my soul",
          this: "And I ain't gotta tell him, I think he knows",
          next: "I think he knows",
          num: 18,
          section: "[Chorus]",
        },
      },
      {
        album: "Lover",
        album_num: 3,
        song: "I Forgot That You Existed",
        line: {
          prev: "I forgot that you existed",
          this: "And I thought that it would kill me, but it didn't",
          next: "And it was so nice",
          num: 38,
          section: "[Chorus]",
        },
      },
      {
        album: "Unspecified Album",
        album_num: 10,
        song: "Only The Young",
        line: {
          prev: "Only the young (Only the young)",
          this: "Only the young (Only the young)",
          next: "Only the young",
          num: 29,
          section: "[Chorus]",
        },
      },
      {
        album: "evermore",
        album_num: 1,
        song: "it's time to go",
        line: {
          prev: "",
          this: "When the dinner is cold and the chatter gets old",
          next: "You ask for the tab",
          num: 1,
          section: "[Verse 1]",
        },
      },
      {
        album: "evermore",
        album_num: 1,
        song: "right where you left me",
        line: {
          prev: "I, I swear you could hear a hair pin drop",
          this: "Right when I felt the moment stop",
          next: "Glass shattered on the white cloth",
          num: 14,
          section: "[Pre-Chorus]",
        },
      },
      {
        album: "Speak Now",
        album_num: 7,
        song: "Haunted",
        line: {
          prev: "From everything we had",
          this: "But I still mean every word I said to you",
          next: "He will try to take away my pain",
          num: 20,
          section: "[Verse 2]",
        },
      },
      {
        album: "Red (Taylor's Version)",
        album_num: 6,
        song: "Nothing New (Taylor's Version) [From the Vault]",
        line: {
          prev: "How did I go from growing up to breaking down?",
          this: "And I wake up (Wake up) in the middle of the night",
          next: "It's like I can feel time moving",
          num: 27,
          section: "[Chorus: Phoebe Bridgers & Taylor Swift]",
        },
      },
      {
        album: "evermore",
        album_num: 1,
        song: "champagne problems",
        line: {
          prev: "Bustling crowds or silent sleepers",
          this: "You're not sure which is worse",
          next: "Because I dropped your hand while dancing",
          num: 4,
          section: "[Verse 1]",
        },
      },
    ],
  ],
};
